import { clientInstance } from '../../client';

/**
 * Returns whether there is an active account session.
 */
export function checkIfHasActiveSession() {
  return Boolean(clientInstance?.getActiveAccount());
}
